import { useEffect, useState } from 'react';
import { getPhotos } from '../api/client';
import { PhotoInfo } from '../api/types';
import BlurFade from '../components/BlurFade';
import PhotoGrid from '../components/PhotoGrid';
import '../assets/styles/Photos.scss';
import { useLanguage } from '../i18n/LanguageContext';

const BLUR_FADE_DELAY = 0.04;

function PhotosPage() {
  const { t } = useLanguage();
  const [photos, setPhotos] = useState<PhotoInfo[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    getPhotos()
      .then(setPhotos)
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section className="page page-wide">
      <BlurFade delay={BLUR_FADE_DELAY} className="page-head">
        <div className="eyebrow eyebrow-acc">
          {t.photos.eyebrow}
          {!loading && !error && ` · ${photos.length} ${t.photos.photosLabel}`}
        </div>
        <h1 className="page-title">{t.photos.heading}</h1>
      </BlurFade>

      {loading && <p className="photos-status">{t.photos.loading}</p>}
      {!loading && error && <p className="photos-status">{t.photos.error}</p>}
      {!loading && !error && photos.length === 0 && <p className="photos-status">{t.photos.noPhotosFound}</p>}

      {!loading && !error && photos.length > 0 && (
        <BlurFade delay={BLUR_FADE_DELAY * 2}>
          <PhotoGrid photos={photos} baseDelay={BLUR_FADE_DELAY * 3} />
        </BlurFade>
      )}
    </section>
  );
}

export default PhotosPage;
